import { render, staticRenderFns } from "./DamageAssessorCaseDocuments.vue?vue&type=template&id=56fa902a&scoped=true"
import script from "./DamageAssessorCaseDocuments.vue?vue&type=script&lang=js"
export * from "./DamageAssessorCaseDocuments.vue?vue&type=script&lang=js"
import style0 from "./DamageAssessorCaseDocuments.vue?vue&type=style&index=0&id=56fa902a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fa902a",
  null
  
)

export default component.exports